import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsDeleteApi, AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import { CustomButton } from "../../CustomButtom";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import axios from "axios";


export default function AllWrittenPaper() {
  const [Projects1, setProjects1] = React.useState([])
  const [Projects2, setProjects2] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [toStudentModel, setToStudentModal] = React.useState(false)
  const [ChangeToStudentBatchModal, setChangeToStudentBatchModal] = React.useState(false)
  const [ImportData, setImportData] = React.useState([])
  const fileRefSingle = React.createRef();
  const [batchID, setBatchID] = React.useState("")
  const [batchName, setBatchName] = React.useState("")
  const [batchList, setBatchList] = React.useState([])
  const [PDF, setPDF] = React.useState("")

  var date = new Date()
  var today = date.toLocaleDateString()

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, slugs.db_slug_user_data)
      .then((res) => {
        setProjects1(res.data.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        setCustomersList(res.data.sort((a, b) => (a.meta.user_name.localeCompare(b.meta.user_name))))
        // setProjects1(res.data)
        // setCustomersList(res.data)
        console.log(res.data[0].meta.user_name)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  var date = new Date()
  var today = date.toLocaleDateString()

  const GetAll = () => {
    GetAllProjects({
      per_page: 4999,
      "filter[meta_query][1][key]": "answer_date",
      "filter[meta_query][1][value][0]": "",
      "filter[meta_query][1][compare]": "!=",
    })
  }
  useEffect(() => {
    GetAll()
  }, [])

  const StudentExportRef = React.useRef(null);
  const StudentExportPrint = useReactToPrint({
    content: () => StudentExportRef.current,
    pageStyle: { margin: 0 }

  })

  const columns = [
    {
      id: 1,
      name: "id",
      selector: (row) => row.meta.user_id,
      sortable: true,
      reorder: true,
      width: "100px"
    },
    {
      id: 31,
      name: "Title",
      selector: (row) => row.title.rendered,
      sortable: true,
      reorder: true,
      width: "150px"

    },
    {
      id: 312,
      name: "Phone",
      selector: (row) => row.meta.user_phone_number,
      sortable: true,
      reorder: true,
      width: "150px"
    },
    {
      id: 32,
      name: "username",
      selector: (row) => row.meta.user_name,
      sortable: true,
      reorder: true
    },
    {
      id: 32,
      name: "role",
      selector: (row) => JSON.parse(row.meta.attendance).length,
      sortable: true,
      reorder: true
    },
    {
      id: 3,
      name: "View",
      cell: (row) => <Link to={`${slugs.student_details}${row.slug}`}>View</Link>,

    }
  ];

  const downloadPDF = async (imageurl, filename) => {
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const imageUrl = "https://api.oppaonnihakwon.com/wp-content/uploads/2025/01/BUTAB.jpeg";
    var nodejsurl = "https://real-exam.epsexam.com/base64"
    await axios({ method: "GET", url: `${nodejsurl}?url=${imageurl}` })
      .then(res => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${res.data.data}`;
        link.download = filename;
        // setBase64(`data:image/jpeg;base64,${res.data.data}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
  };

  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Students</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Students
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                setProjects1(CustomersList)
              }}
            >
              All ({CustomersList.length}) |
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
              }}
            >
              <input style={{ margin: "1px 2px", padding: "3px 2px" }}
                value={""} placeholder="Phone" type="date"
                onChange={(event) => {
                  // setCustomersList(event.target.value)
                  console.log(event.target.value)
                  const [year, month, day] = event.target.value.split("-");
                  console.log(`${day}/${month}/${year}`)

                  setProjects1(CustomersList.filter(a => a.meta.answer_date.includes(`${day}/${month}/${year}`)))
                }}
              />
            </div>
            <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}
              onClick={() => {
                for (let i = 0; i < Projects1.length; i++) {
                  const item = Projects1[i]
                  downloadPDF(item.meta.answer_sheet,item.meta.user_name)
                }
              }}
            >
              Download All
            </div>
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        {/* <DataTable
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          columns={columns}
          data={Projects1}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          onSelectedRowsChange={(r) => {
            console.log("asdasd", r)
            setProjects2(r.selectedRows)
          }}
          pagination
          selectableRows
        /> */}
        <div ref={StudentExportRef} >
          {/* <div>Total Present today: {GetTotal(Projects1)}</div> */}
          <table>
            <thead>
              <tr>
                <td>SN</td>
                <td>Name</td>
                <td>Roll Number</td>
                <td>Phone Number</td>
                <td>Answer Sheet</td>
              </tr>
            </thead>
            {Projects1.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.title.rendered}</td>
                <td>{item.meta.user_name}</td>
                <td>{item.meta.user_phone_number}</td>
                {/* <td>{JSON.parse(item.meta.attendance).length}</td> */}
                <td>{item.meta.answer_date}</td>
                <td style={{ cursor: "pointer" }} onClick={() => {
                  setPDF(item.meta.answer_sheet)
                }}>Open</td>
                {/* <td style={{ cursor: "pointer" }}>
                  <div onClick={() => {
                    // setPDF(item.meta.answer_sheet)
                    AdsPUTApi({
                      meta: {
                        answer_date: `${today}`,
                        answer_sheet: `${URL}`
                      }
                    }, slugs.db_slug_user_data, UserID)
                      .then(res => {
                        setReload(false)
                        window.location.reload();
                      })
                  }}
                  >Upload PDF</div>
                </td> */}
                {/* <td></td> */}
              </tr>
            ))}
          </table>
        </div>
      </div>

      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {PDF !== "" &&
        <div className="modal center image-zoom-modal"
          onClick={() => {
            setPDF("")
          }}
        >
          <iframe src={PDF}
            style={{ width: "80vw", height: "80vh" }}

          ></iframe>
        </div>
      }


    </div>
  )
}


const GetTotal = (Projects1) => {
  var ValidAttendance = Projects1.filter(a => a.meta.attendance !== "")
  var TodayPresent = 0;

  var date = new Date()
  var today = date.toLocaleDateString()
  for (let i = 0; i < ValidAttendance.length; i++) {
    if (JSON.parse(ValidAttendance[i].meta.attendance).filter(a => a == `${today}`).length !== 0)
      TodayPresent++
    console.log(JSON.parse(ValidAttendance[i].meta.attendance).filter(a => a == `${today}`))
  }
  return TodayPresent

}